import { render, staticRenderFns } from "./orderModel.vue?vue&type=template&id=02f51634&scoped=true&"
import script from "./orderModel.vue?vue&type=script&lang=js&"
export * from "./orderModel.vue?vue&type=script&lang=js&"
import style0 from "./orderModel.vue?vue&type=style&index=0&id=02f51634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f51634",
  null
  
)

export default component.exports